import { roundCents } from "common/decimal";
import Commodity from "domain/commodity";
import { Unit } from "domain/unit";
import * as NP from "number-precision";

export function roundBid(price: number, isSettled: boolean, commodity: Commodity, selectedUnit: Unit): number {
    return roundCents(convertPriceToSelectedUnit(price, commodity, selectedUnit), isSettled ?
        commodity.roundingOnClose : commodity.roundingInSession)
}

export function convertPriceToSelectedUnit(price: number, commodity: Commodity, selectedUnit: Unit): number {
    if (selectedUnit.id === commodity.baseUnit.id)
        return price;
    return NP.divide(price, selectedUnit.conversionRate)
}